import { Space, Typography } from "antd";
// import { UserAvatar } from "@rumble-it/common-components/src/components/UserAvatar";
import { Link } from "react-router-dom";
import { Claim } from "@rumble-it/common-lib/types/models/Claim.interface";
import { CarOutlined, UserOutlined } from "@ant-design/icons";
import { Card, LicensePlate } from "@rumbledirect/ui";

interface KanbanCardProps {
  claim: Claim;
}

const { Text } = Typography;

export const ClaimKanbanCard = ({ claim }: KanbanCardProps) => {
  return (
    <Link to={`/claims/dossiers/${claim?.dossier?.id}`}>
      <Card
        className="hover:shadow-md cursor-pointer"
        size="small"
        key={claim?.id}
      >
        <Space direction="vertical" size={8} style={{ width: "100%" }}>
          <Space align="start" className="w-full justify-between">
            <LicensePlate country="NL">
              {claim?.dossier?.vehicle?.licensePlate?.identifier}
            </LicensePlate>
            {/* TODO: Await task module */}
            {/* {dossier?.assignee && <UserAvatar fullName={dossier?.assignee} />} */}
          </Space>
          <Space>
            <CarOutlined />
            <Text>
              {claim?.dossier?.vehicle?.brand} {claim?.dossier?.vehicle?.model}
            </Text>
          </Space>
          <Space>
            <UserOutlined />
            <Text>{claim?.dossier?.driver?.fullName}</Text>
          </Space>
        </Space>
      </Card>
    </Link>
  );
};
